module.exports = __webpack_public_path__ + "static/media/phone-icon.0d1f5125.svg";